
import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import Message from '@beisen-phoenix/message'
import { Button, Form, DatePicker, Tag, Spin } from 'antd'

import moment from 'moment'
import 'moment/locale/zh-cn'
import locale from 'antd/es/date-picker/locale/zh_CN'
import { getUrlParams, closeModel } from '../../../utils'
import { DATEFORMAT } from '../../../utils/date-format'
import './index.scss'

moment.locale('zh-cn')

const Invitation = () => {
    const [loading, setLoading] = useState(true)//loading
    const [submitLoading, setSubmitLoading] = useState(false)//submitLoading
    const [open, setOpen] = useState(false)//DatePicker组件是否显示
    // const [formDisabled, setFormDisabled] = useState(false)//form是否禁用
    const [selectedInternshipDate, setSelectedInternshipDate] = useState([])//选中的实习日期
    const [applyInfo, setApplyInfo] = useState({//申请相关信息
        applyIds: [],//申请ids
        tenantId: null,//tenantId
        userId: null//userId
    })//选中的实习日期

    const [form] = Form.useForm()
    const internshipDateBoxEl = useRef(null)

    const {
        tenantId,//tenantId
        commonParamater,
    } = getUrlParams()

    useEffect(() => {
        //获取申请相关信息
        axios.get('/api/jingShun/getApplyInfo', {
            params: {
                tenantId,
                commonParamater,
            }
        })
            .then(res => {
                const {
                    code,
                    message,
                    data
                } = res.data
                if (code === '200') {
                    data && setApplyInfo(data)
                } else {
                    Message.error({ message: message || '服务器异常' })
                }
            }, error => {
                Message.error({ message: error.message });
            }).finally(() => setLoading(false))
    }, [])

    //监听实习日期DatePicker应该何时关闭
    useEffect(() => {
        function listenDatePicker(evevt) {
            if (!internshipDateBoxEl.current.contains(evevt.target)) {
                setOpen(false)
            }
        }
        window.addEventListener('click', listenDatePicker, true)
        return () => window.removeEventListener('click', listenDatePicker, true)
    }, [])

    //发送邮件
    const onFinish = (values) => {
        setSubmitLoading(true)
        axios.post('/api/jingShun/sendEmail', {
            applyInfo,
            internshipDate: values.internshipDate.map(v => v.toString()),
            disabledDate: values.disabledDate.format(DATEFORMAT),
        })
            .then(res => {
                const {
                    code,
                    message,
                } = res.data
                if (code === '200') {
                    // setFormDisabled(true)
                    //Message.success({ message: message || '请关注italent消息' })
                    closeModel(message)
                } else {
                    Message.error({ message: message || '服务器异常' })
                }
            }, error => {
                Message.error({ message: error.message })
            }).finally(() => setSubmitLoading(false))
    }

    const onInternshipDateChange = (date, dateString) => {
        if (dateString && !selectedInternshipDate.includes(dateString)) {
            const newValue = [...selectedInternshipDate, dateString].sort((a, b) => a.localeCompare(b))
            setSelectedInternshipDate(newValue)
            let aaa = form.setFieldValue('internshipDate', newValue)
            form.validateFields(['internshipDate'])
        }
    }
    const onDeleteDateInternship = (v) => {
        const newValue = selectedInternshipDate.filter(value => value !== v)
        setSelectedInternshipDate(newValue)
        form.setFieldValue('internshipDate', newValue)
        form.validateFields(['internshipDate'])
    }
    const disabledDate = current => current < moment().startOf('day')

    return (
        <Spin spinning={loading}>
            <div className='internship-invitation'>
                <div className='internship-invitation-header'>
                    发起实习邀请
                </div>
                <Form
                    form={form}
                    // disabled={formDisabled}
                    className='internship-invitation-body'
                    initialValues={{
                        internshipDate: [],
                    }}
                    labelCol={{
                        span: 4,
                    }}
                    onFinish={onFinish}
                >
                    <Form.Item
                        label="实习报到日期"
                        name="internshipDate"
                        rules={[
                            {
                                required: true,
                                message: '请选择实习报到日期',
                            },
                        ]}
                        validateTrigger="onChange"
                    >
                        <div className='internship-date-box'>
                            <div ref={internshipDateBoxEl}>
                                <Button className='internship-date-button' onClick={() => setOpen(true)}>
                                    添加日期
                                </Button>
                                <DatePicker
                                    className='internship-date-picker'
                                    placement="leftBottom"
                                    locale={locale}
                                    open={open}
                                    onChange={onInternshipDateChange}
                                    getPopupContainer={() => internshipDateBoxEl.current}
                                    disabledDate={disabledDate}
                                />
                            </div>
                            <div>
                                {
                                    selectedInternshipDate.map(v => (
                                        <Tag color="cyan" className='internship-date-tag' key={v} closable onClose={(e) => onDeleteDateInternship(v)}>
                                            {v}
                                        </Tag>
                                    ))
                                }
                            </div>
                        </div>
                    </Form.Item>
                    <Form.Item
                        label="失效日期"
                        name="disabledDate"
                        rules={[
                            {
                                required: true,
                                message: '请选择失效日期',
                            },
                        ]}
                    >
                        <DatePicker className='internship-date' placeholder='请选择失效日期' locale={locale} inputReadOnly={true} disabledDate={disabledDate} />
                    </Form.Item>
                </Form>
                <div className='internship-invitation-footer'>
                    <Button onClick={() => closeModel('取消操作')}>
                        取消
                    </Button>
                    <Button className='internship-invitation-submit' type="primary" htmlType="submit" onClick={() => form.submit()} loading={submitLoading}>
                        {
                            submitLoading ? '发送中' : '确定'
                        }
                    </Button>
                </div>
            </div>
        </Spin>
    )
}

export default Invitation